export enum RouteName {
  HOME = '/',
  SEARCH = '/buscar',
  MY_PROFILE = '/mi-perfil',
  MY_PURCHASES = '/mis-compras',
  MY_FAVORITES = '/mis-favoritos',
  PURCHASE_DETAILS = '/compra/:purchaseCode',
  PRODUCT_DETAILS = '/producto/:productSlug',
  PURCHASE_CHECKOUT = '/finalizar-compra',
  PURCHASE_RESULT = '/resultado-compra',
  PURCHASE_PAYMENT_PROCESSING = '/pago',
  COLLECTIONS = '/colecciones/:collectionSlug',
}
